import axios from 'axios';

export const fetchSlideSequence = async (scenarioId) => {
    const { data } = await axios.get(`/api/scenarios/${scenarioId}`);
    return data;
};

export const updateSlideSequence = async ({ sequence, isDefault }) => {
    const slideIds = sequence.map(slide => slide.id);
    
    await axios.put('/api/scenarios', { sequence: slideIds, isDefault });
};
